import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={38}
    height={38}
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M33.25 15.4375H21.375C19.4156 15.4375 17.8125 17.0407 17.8125 19V20.1875H12.2669L6.8875 16.15C5.795 15.3307 4.37 15.2119 3.15875 15.8175C1.9475 16.4232 1.1875 17.6463 1.1875 19V20.1875C1.1875 20.5675 1.3775 20.9357 1.68625 21.1494L9.09625 26.4457L7.05375 29.7588C5.42688 30.0913 4.19187 31.5282 4.19187 33.25C4.19187 35.2094 5.795 36.8125 7.75438 36.8125C9.71375 36.8125 11.3169 35.2094 11.3169 33.25C11.3169 32.8344 11.2338 32.4307 11.1031 32.0625H29.9131C29.7825 32.4307 29.6994 32.8344 29.6994 33.25C29.6994 35.2094 31.3025 36.8125 33.2619 36.8125C35.2212 36.8125 36.8244 35.2094 36.8244 33.25C36.8244 31.7063 35.8269 30.4 34.4494 29.9013V27.3125H35.6369C36.29 27.3125 36.8244 26.7782 36.8244 26.125V19C36.8244 17.0407 35.2212 15.4375 33.2619 15.4375H33.25ZM20.1875 19C20.1875 18.3469 20.7219 17.8125 21.375 17.8125H33.25C33.9031 17.8125 34.4375 18.3469 34.4375 19V20.1875H20.1875V19ZM32.0625 29.6875H9.88L11.3406 27.3125H32.0506V29.6875H32.0625Z"
      fill="url(#paint0_linear_4437_319)"
    />
    <path
      d="M13.0625 16.625C17.3138 16.625 20.7812 13.1575 20.7812 8.90625C20.7812 4.655 17.3138 1.1875 13.0625 1.1875C8.81125 1.1875 5.34375 4.655 5.34375 8.90625C5.34375 13.1575 8.81125 16.625 13.0625 16.625ZM9.88 7.71875H11.875V5.72375C11.875 5.07063 12.4094 4.53625 13.0625 4.53625C13.7156 4.53625 14.25 5.07063 14.25 5.72375V7.71875H16.245C16.8981 7.71875 17.4325 8.25313 17.4325 8.90625C17.4325 9.55937 16.8981 10.0938 16.245 10.0938H14.25V12.0888C14.25 12.7419 13.7156 13.2763 13.0625 13.2763C12.4094 13.2763 11.875 12.7419 11.875 12.0888V10.0938H9.88C9.22687 10.0938 8.6925 9.55937 8.6925 8.90625C8.6925 8.25313 9.22687 7.71875 9.88 7.71875Z"
      fill="url(#paint1_linear_4437_319)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4437_319"
        x1={36.8244}
        y1={36.8125}
        x2={17.9651}
        y2={5.37213}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#223E76" />
        <stop offset={0.511069} stopColor="#365699" />
        <stop offset={1} stopColor="#2BA9B4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4437_319"
        x1={20.7812}
        y1={16.625}
        x2={5.34375}
        y2={1.1875}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#223E76" />
        <stop offset={0.511069} stopColor="#365699" />
        <stop offset={1} stopColor="#2BA9B4" />
      </linearGradient>
    </defs>
  </svg>
);
export default SVGComponent;
